<template>
  <div class="boxs">
    <div class="title">
      <p>
        高考从不是高三一年的事，是考生十二年的努力在今朝绽放，很多有远见的家长/考生在高一或高二就开始了解升学途径，也有很多家长/考生认为只有参加普通高考这一条路，多元化的名校升学路径早已成为一种趋势。
      </p>
    </div>
    <div class="title1">
      <div class="top">
        <div class="y">&nbsp;</div>
        <div class="top_title">学生升学路径什么时候要开始考虑？</div>
      </div>
      <div class="btn">
        <div>
          建议将开始考虑的时间放在高一入学半个学期后，而把做出初步决定的时间高一暑假结束前，为什么呢？因为制定升学计划、选择升学路径，还是应该是越早越好的。如果是高三年级的话，我现在再跟他讲有哪些升学路径，有些来不及了。
        </div>
        <div>
          对于高二的同学来说，如果“6选3学科”选择了地理或者生命科学，那么高二结束前就可以参加等级考，相当于高考提前到来，这基本上也是高一暑假，甚至高一寒假就要做出的选择。
          所以，升学方面的“学职定位/生涯定向”最好是在高一学年里完成。但这个是初步的，后期是可以调整的。比如高一选择了地理或生命科学在高二时参加等级考，但如果高二参加第一次模拟考试成绩不够理想，在正式考试报名前还可以更改的（但这也“浪费”了很多时间）。
        </div>
      </div>
    </div>
    <div class="title1" style="margin-bottom: 40px">
      <div class="top" style="margin-bottom: 16px">
        <div class="y">&nbsp;</div>
        <div class="top_title">
          学生升学路径有哪些（无国际部、无国际课程的班里）？
        </div>
      </div>
      <div class="btn1">
        <img src="./images/Group30.png" alt="" />
      </div>
    </div>
    <div class="title1" style="padding-bottom: 40px">
      <div class="top" style="margin-bottom: 16px">
        <div class="y">&nbsp;</div>
        <div class="top_title">
          国内升学路径早知道，仅供家长/考生参考选择，进行升学规划
        </div>
      </div>
      <div class="btn2">
        <img src="./images/Group31.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HXproject",
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style scoped lang="less">
.boxs {
  background-color: #fff;
  width: 100%;
  height: 100%;
  margin: 0 32px;
  .title {
    width: 90%;
    height: 80px;
    background: #ebf0ff;
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
    font-size: 18px;
    margin-bottom: 45px;
    color: #333;
    box-sizing: border-box;
    p {
      padding: 16px;
    }
  }
  .title1 {
    .top {
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      .y {
        width: 14px;
        height: 14px;
        background: #3964e6;
        opacity: 1;
        border-radius: 50%;
        margin-right: 9px;
      }
      .top_title {
        font-size: 18px;
        color: #333;
      }
    }
    .btn {
      font-size: 16px;
      color: #666;
      margin-left: 24px;
      margin-bottom: 32px;
      div {
        width: 91%;
      }
    }
    .btn1 {
      width: 90%;
      height: 566px;
      background: #f8f9ff;
      border-radius: 16px 16px 16px 16px;
      opacity: 1;
      img {
        width: 100%;
      }
    }
    .btn2 {
      width: 90%;
      height: 406px;
      background: #f8f9ff;
      border-radius: 16px 16px 16px 16px;
      opacity: 1;
      img {
        width: 100%;
      }
    }
  }
}
</style>
